import React, {Component} from 'react';
import AccountExpenseContainer from '../../../containers/account_expense_container';
import Loader from '../../universal/loader';
import {Button, Form, Grid, Header, Message, Segment} from "semantic-ui-react";
import * as hinchLogo from "../../../assets/hinchWhitebackgroundLogo.png";
import {APP_URL, BASE_URL} from "../../../constants/app_routes";
import {handleFileDownload} from "../../../utils/download_file";
import DownloadingIntent from "../../universal/toast";

class ViewExpense extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expenseStatus: undefined,
            message: undefined,
            expenseId: undefined,
            action:'view'
        }
    }

    componentWillMount() {
        this.setState({expenseId: this.props.match.params.expenseId});
        this.props.getExpenseDetails(this.props.match.params.expenseId)
    }

    handleChangeStatus = () => {
        const formData = new FormData();
        formData.append("expense_id", this.state.expenseId);
        formData.append("status", this.state.expenseStatus);
        this.props.changeExpenseStatus(formData,this.state.expenseId,this.onSuccessCallBack);
    };

    onSuccessCallBack = (response) => {
        if (response.success) {
            this.setState({message: 'Successfully changed expense Status'});
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
    };

    handleDownload = async () => {
        this.setState({isDownloading:true,showDownload:true});
        const URL = BASE_URL+"/pdf/expense/"+this.state.expenseId;
        const fileName = this.props.expenseDetail['filename'];
        await handleFileDownload(URL,fileName);
        this.setState({isDownloading:false});
    };

    render() {
        const expenseDetail = this.props.expenseDetail;
        const mapStatus = {"processed": 0, "paid": 1};
        const expenseStatus = [{key: 1, text: "Approved", value: 0}, {key: 2, text: "Paid", value: 1}];
        return (<div style={{width: '80%', margin: 'auto'}}>
            {this.props.isFetching && <Loader/>}
            {!this.props.isFetching && expenseDetail && <div style={{width: '95%', margin: 'auto'}}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Header size="large" content={"Expense ID :" + expenseDetail['expense_number']}
                                    textAlign="left"/>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Header size="large" content={expenseDetail['date']} textAlign="right"/>
                        </Grid.Column>
                    </Grid.Row>

                    {this.state.message && <Grid.Row>
                        <Grid.Column width={8}>

                        </Grid.Column>
                        <Grid.Column width={8}>
                            <div>
                                <Message positive content={<span className="format-bold">{this.state.message}</span>}
                                         onDismiss={() => {
                                             this.setState({message: undefined})
                                         }}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>}

                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#249AC4', color: 'white', height: '100%'}}>
                                <div>
                                    <Grid stackable style={{marginTop: '0'}}>
                                        <Grid.Row style={{padding: '0 0 1% 0'}}>
                                            <Grid.Column width={5}>
                                                <img src={hinchLogo} alt="Hinch property logo"/>
                                            </Grid.Column>
                                            <Grid.Column width={11}>
                                                <div>
                                                    <div>
                                                        <p className="format-bold">Address</p>
                                                        <span>
                                                                Suite 3, First Floor Offices
                                                            </span>
                                                        <span>
                                                                East House,Chiltern Avenue,Amersham
                                                            </span>
                                                        <p>
                                                            Bucks, HP6 5AE
                                                        </p>
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row style={{textAlign: 'center'}}>
                                            <div style={{width: '50%'}}>
                                                VAT Reg No: ASD453
                                            </div>
                                            <div style={{width: '50%'}}>
                                                Terms: On Receipt
                                            </div>
                                        </Grid.Row>
                                    </Grid>
                                </div>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#F9FAFB', height: '100%'}}>
                                <div>
                                    <p className="format-bold"> Expense To</p>
                                    <dl>
                                        <dt>Name</dt>
                                        <dd>: {expenseDetail['clerk_profile_name']}</dd>
                                        <dt>Address</dt>
                                        <dd>: Expense Address</dd>
                                        <dt>Email</dt>
                                        <dd>:{expenseDetail['clerk_profile_email']}</dd>
                                    </dl>
                                </div>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <table width="100%" border="1" cellPadding="0" cellSpacing="0"
                                   style={{borderCollapse: 'collapse', borderColor: '#f5f5f5'}}>
                                <tbody>
                                <tr style={{backgroundColor: '#249AC4', color: 'white', height: '30px'}}>
                                    <th>Date</th>
                                    <th>Agent Ref.Id</th>
                                    <th>Property Address</th>
                                    <th>Note</th>
                                    <th>AEC</th>
                                    <th>Train</th>
                                    <th>Parking</th>
                                    <th>Fuel</th>
                                    <th>Amount</th>
                                </tr>
                                {expenseDetail['pipeline_expenses'].map((estimate, i) => {
                                    return (
                                            <tr className="icon-button" key={estimate.id} onDoubleClick={()=>{window.open(APP_URL+"/account/expense/pipeline/view/"+estimate.id)}}>
                                                <td className="center-aligned">{estimate.inspection['inspection_time']['inspection_date']}</td>
                                                <td className="center-aligned">{estimate.inspection['reference_id']}</td>
                                                <td width="20%" style={{padding: '1%'}}>{estimate.inspection['property_address']}</td>
                                                <td width="20%">{estimate['notes']}</td>
                                                <td className="center-aligned">£ {estimate['aec']}</td>
                                                <td className="center-aligned">£ {estimate['train']}</td>
                                                <td className="center-aligned">£ {estimate['parking']}</td>
                                                <td className="center-aligned">£ {estimate['fuel']}</td>
                                                <td className="center-aligned">£ {estimate['total_amount']}</td>
                                            </tr>
                                    )
                                })
                                }
                                <tr>
                                    <td colSpan={7} className="right-aligned format-bold pad-all">Total Expense Amount
                                    </td>
                                    <td colSpan={2}
                                        className="format-bold center-aligned">£ {expenseDetail['total_amount']}</td>
                                </tr>
                                </tbody>

                            </table>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                        </Grid.Column>
                        {(expenseDetail.status !== "paid" && this.props.userRole === 'admin') ? <Grid.Column width={8}>
                            <div style={{height: '100px'}}>
                                <div>
                                <span className="format-bold half-wide">
                                    Expense Status :
                                </span>
                                    <span className="half-wide">
                                    <Form.Dropdown selection
                                                   placeholder="Expense Status"
                                                   fluid
                                                   options={expenseStatus}
                                                   defaultValue={mapStatus[expenseDetail.status]}
                                                   onChange={(e,option) => {
                                                       this.setState({expenseStatus:option.value })
                                                   }}
                                    />
                                </span>
                                </div>
                                <div className="right-aligned pad-top">
                                    <Button content="Download" primary onClick={this.handleDownload}/>
                                    <Button content="Change Status" primary onClick={() => this.handleChangeStatus()}/>
                                </div>
                            </div>
                        </Grid.Column> : <Grid.Column width={8}>
                            <Header textAlign="center" content={<div><span>Expense has been</span><span style={{color:'green'}}> PAID</span></div>}/>
                            <div className="pad-top center-aligned">
                                <Button content="Download" primary onClick={this.handleDownload}/>
                            </div>
                        </Grid.Column>}
                    </Grid.Row>
                </Grid>

            </div>
            }
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
        </div>);
    }
}

export default AccountExpenseContainer(ViewExpense);


// WEBPACK FOOTER //
// ./src/views/accounts/expense/view_expense.js